<template>
  <div class="col-12 col-md-12 col-lg-12 card-col">
    <div class="card-ct card-rounded-shadowed">
      <div class="row">
        <div class="col-lg-12">
          <h2>{{$t('activities_component_title')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div v-if="dataLoading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else-if="!data.length" class="mt-3">
            {{ $t('activities_component_no_data') }}
          </div>
          <div v-else class="accordion accordion-table achievements-table" id="recent-visits-table">
            <div v-for="(activity, index) in data" :key="index">
              <div v-if="activity.activity_type === 'deposit'">
                <div :id="itemPrefix + 'item-' + index">
                  <a href="#"
                     v-if="activity.deposits.length > 0"
                     @click="setExpand($event, itemPrefix + 'item' + index)"
                     :class="(visitExpanded[itemPrefix + 'item' + index] ? '' : 'collapsed ') + 'row toggle-row'"
                     data-toggle="collapse"
                     :data-target="'#' + itemPrefix + 'collapse-' + index"
                     aria-expanded="true"
                     aria-controls="collapseOne">
                    <div class="offset-1 col-11 pb-0">
                      <small>{{ $t('activity_' + activity.activity_type) }}</small>
                    </div>
                    <div class="col-sm-1 indicator-arrow"><span></span></div>
                    <div class="col-12 col-sm-2 date-col">{{ activity.time | momentTz('D. MMMM YYYY HH:mm') }}</div>
                    <div class="col-12 col-sm-5 points-col">{{ activity.credit_sum > 0 ? '+' + activity.credit_sum : 0 }} <small>{{ 'punkti' }}</small></div>
                    <div class="col-12 col-sm-4 place-col">{{ activity.address }}</div>
                  </a>
                  <div v-else class="collapsed row toggle-row">
                    <div class="offset-sm-1 col-sm-11 col-12 pb-1 pb-sm-0">
                      <small>{{ $t('activity_' + activity.activity_type) }}</small>
                    </div>
                    <div class="col-12 offset-sm-1 col-sm-2 date-col">{{ activity.time | momentTz('D. MMMM YYYY HH:mm') }}</div>
                    <div class="col-12 col-sm-5 points-col">{{ activity.credit_sum }} <small>{{ 'punkti' }}</small></div>
                    <div class="col-12 col-sm-4 place-col">{{ activity.address }}</div>
                  </div>
                </div>
                <collapse-transition :duration="350" easing="ease-in-out" v-if="activity.deposits.length > 0">
                  <div v-show="visitTransitioned[itemPrefix + 'item' + index]"
                       :id="itemPrefix + 'collapse-' + index"
                       :class="(visitExpanded[itemPrefix + 'item' + index] ? 'show ' : '') + 'collapse'"
                       :aria-labelledby="itemPrefix + 'item' + index" >
                    <p class="pt-3 mb-0"><strong>{{ $dt('objects', 'Objekti', 'global') }}:</strong></p>
                    <div class="horizontal-graph-ct">
                      <div class="horizontal-graph">
                        <div v-for="(deposit, index) in activity.deposits" :key="index" class="teal"
                          :style="getProgressBarStyle(deposit.deposit_count, activity.deposit_count_sum, deposit.color)">{{ deposit.deposit_count }}</div>
                      </div>
                      <div class="legend">
                        <div class="legend-item" v-for="(deposit, index) in activity.deposits" :key="index">
                          <div class="legend-label" :style="'background-color: ' + deposit.color + ';'"></div>
                          <p>{{ $t(deposit.title, 'global') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </collapse-transition>
              </div>
              <div v-else>
                <div :id="'item-' + index">
                  <div class="collapsed row toggle-row table-row">
                    <div class="offset-sm-1 col-sm-11 col-12 pb-2 pb-sm-0">
                      <small>{{ $t('activity_' + activity.activity_type) }}</small>
                    </div>
                    <div class="col-12 offset-sm-1 col-sm-2 date-col">{{ activity.time | momentTz('D. MMMM YYYY HH:mm') }}</div>
                    <div class="col-12 col-sm-5 points-col">{{ activity.credit_sum }} <small>{{ 'punkti' }}</small></div>
                    <div class="d-none col-12 col-sm-5 achievement-col">
                    </div>
                    <div class="col-12 col-sm-3 code-col">
                      <span class="code-title achievement-title">{{ activity.name }}</span>
                      <div v-if="activity.discount_code">
                        <span class="code-title">{{$t('activities_coupon_code')}}</span>
                        <span>{{ activity.discount_code }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="data.length > 0">
            <div class="col-12 mt-3">
              <Pagination class="justify-content-center" :data="paginationData" :limit="5" @pagination-change-page="onPageChange"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollapseTransition from '@ivanv/vue-collapse-transition';
import Pagination from 'laravel-vue-pagination';
import Vue from 'vue';

export default {
  components: {
    CollapseTransition,
    Pagination
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    paginationData: {
      default: null,
      required: true
    },
    itemPrefix: {
      default: '',
      required: false,
      type: String
    },
    dataLoading: {
      default: true,
      required: false,
      type: Boolean
    }
  },
  data () {
    return {
      visitExpanded: {},
      visitTransitioned: {},
    }
  },
  watch: {
    data: {
      handler() {
        this.visitExpanded = {};
        this.visitTransitioned = {};
      },
      deep: true
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    setExpand (e, item) {
      e.preventDefault();
      if (!this.visitExpanded[item]) {
        Vue.set(this.visitExpanded, item, true);
        Vue.set(this.visitTransitioned, item, true);
      } else {
        let that = this;
        Vue.set(this.visitTransitioned, item, false);
        setTimeout(function () {
          Vue.set(that.visitExpanded, item, false);
        }, 350);
      }
    },
    getProgressBarStyle(count, totalCount, color) {
      if (totalCount > 0) {
        return 'width: ' + ((count / totalCount) * 100).toFixed(4) + '%; background-color:' + color + ';';
      } else {
        return 'background-color: ' + color + ';';
      }
    },
    onPageChange(page) {
      if (parseInt(page) !== parseInt(this.paginationData.current_page)) {
        this.$emit('pageChange', page);
      }
    },
  }
}
</script>

<style scoped>
.code-title {
  background: #fff !important;
  color: black !important;
}
</style>